export default __webpack_public_path__ + "static/media/wrench.cbcd63f2.png";